import type { Component } from "vue";
import type { DecorationBinding } from "#ui/decoration/types";
import CardPriceSplit from "./cardPriceSplit/CardPriceSplit.vue";
import CardPriceText from "./cardPriceText/CardPriceText.vue";

export interface CardPriceControl {
	prefix: string;
	price: string;
	prefixAttrs: DecorationBinding;
	valueAttrs: DecorationBinding;
}

export const CARD_PRICE_DEFAULT = "text";

export const cardPriceVariants: Record<string, Component> = {
	text: CardPriceText,
	split: CardPriceSplit,
};
